document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".c-product-card__add-button[data-variant-id]")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        // ローディング状態
        button.disabled = true;
        button.classList.add("is-loading");

        try {
          // カートコンポーネントを検出
          const cartDrawer = document.querySelector("cart-drawer");
          const cartNotification = document.querySelector("cart-notification");
          const cartComponent = cartDrawer || cartNotification;

          // セクションIDを収集
          // cartComponent があればそこから getSectionsToRender() を呼ぶ
          let sectionsParam = "";
          if (
            cartComponent &&
            typeof cartComponent.getSectionsToRender === "function"
          ) {
            sectionsParam = cartComponent
              .getSectionsToRender()
              .map((s) => s.section || s.id)
              .join(",");
          }

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              sections: sectionsParam || "cart-notification,cart-icon-bubble",
              sections_url: window.location.pathname,
            }),
          });

          if (!response.ok) {
            const err = await response.json();
            throw new Error(err.description || "カートへの追加に失敗しました");
          }

          const data = await response.json();

          // カートコンポーネントに描画を委譲（ドロワー / ポップアップ 共通）
          if (
            cartComponent &&
            typeof cartComponent.renderContents === "function"
          ) {
            cartComponent.renderContents(data);
          }

          // カートタイプが "Page" の場合はカートページへ遷移
          if (!cartComponent) {
            window.location.href = window.Shopify?.routes?.cart_url ?? "/cart";
            return;
          }
        } catch (error) {
          console.error(error);
        } finally {
          // 成功・失敗どちらでも必ずローディングを解除
          button.classList.remove("is-loading");
          button.disabled = false;
        }
      });
    });
});
